// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { fetchDoctors } from "../lib/api";
// import { Award, Check, ArrowRight, Star } from "lucide-react";
// import Reveal from "../components/Reveal";
// import SEO from "../components/SEO";

// export default function Doctors() {
//   const [doctor, setDoctor] = useState(null);
//   useEffect(() => { fetchDoctors().then(d => setDoctor(d[0])); }, []);

//   if (!doctor) return <div className="pt-32 text-center text-inkmuted min-h-screen">Loading…</div>;

//   return (
//     <div data-testid="doctors-page" className="pt-32 pb-16 px-5 md:px-8">
//       <SEO
//         title="Dentist in Ghaziabad | Dr Prateek Aggarwal"
//         description="Meet Dr. Prateek Aggarwal, trusted dentist in Ghaziabad providing dental implants, RCT, smile makeover, whitening and specialist dental care."
//         path="/doctors"
//         keywords="Dr Prateek Aggarwal, dentist Ghaziabad, dental doctor Sahibabad, best dentist Ghaziabad"
//       />
//       <section className="max-w-5xl mx-auto text-center mb-14">
//         <div className="eyebrow mb-3">Meet Our Doctor</div>
//         <h1 className="h-display text-5xl md:text-7xl text-ink mb-6">Hands you can<br /><span className="italic text-cocoa">truly trust.</span></h1>
//       </section>

//       <section className="max-w-7xl mx-auto">
//         <Reveal>
//           <div className="grid md:grid-cols-12 gap-8 rounded-[2rem] bg-beige overflow-hidden" data-testid="doctor-hero-card">
//             <div className="md:col-span-5 aspect-[4/5] md:aspect-auto">
//               <img
//                 src="/images/drprateek.jpeg"
//                 alt={doctor.name}
//                 className="w-full h-full object-cover object-top"
//               />
//             </div>
//             <div className="md:col-span-7 p-8 md:p-12 flex flex-col justify-center">
//               <div className="flex items-center gap-2 mb-4">
//                 <Star size={14} className="text-cocoa fill-cocoa" />
//                 <span className="eyebrow text-cocoa">4.9 Rating · Trusted by Patients</span>
//               </div>
//               <h2 className="h-display text-4xl md:text-6xl text-ink mb-3 leading-[1.05]">{doctor.name}</h2>
//               <div className="text-sm uppercase tracking-[0.18em] text-mocha font-semibold mb-4">{doctor.designation}</div>
//               <div className="flex flex-wrap gap-2 mb-6">
//                 <span className="px-4 py-1.5 rounded-full bg-bgmain text-xs text-ink">{doctor.experience}</span>
//                 <span className="px-4 py-1.5 rounded-full bg-bgmain text-xs text-ink">{doctor.qualifications}</span>
//                 <span className="px-4 py-1.5 rounded-full bg-ink text-bgmain text-xs flex items-center gap-1.5"><Award size={12} /> NABH Accredited</span>
//               </div>
//               <p className="text-inkmuted leading-relaxed mb-7">{doctor.bio}</p>
//               <Link to="/booking" className="liquid-glass-dark inline-flex items-center gap-2 self-start" data-testid="doctor-book-btn">Book Consultation <ArrowRight size={16} /></Link>
//             </div>
//           </div>
//         </Reveal>

//         <div className="grid md:grid-cols-2 gap-6 mt-10">
//           <Reveal>
//             <div className="rounded-3xl bg-bgmain border border-cream p-8 h-full">
//               <div className="eyebrow mb-4">Areas of Expertise</div>
//               <ul className="space-y-3">
//                 {doctor.expertise?.map(e => (
//                   <li key={e} className="flex gap-3 text-ink">
//                     <Check size={18} className="text-cocoa flex-shrink-0 mt-0.5" />
//                     <span>{e}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </Reveal>
//           <Reveal delay={0.1}>
//             <div className="rounded-3xl bg-ink text-bgmain p-8 h-full">
//               <div className="eyebrow text-cream mb-4">Credentials</div>
//               <ul className="space-y-3">
//                 {doctor.credentials?.map(c => (
//                   <li key={c} className="flex gap-3 text-bgmain/85">
//                     <Award size={18} className="text-cream flex-shrink-0 mt-0.5" />
//                     <span>{c}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </Reveal>
//         </div>
//       </section>
//     </div>
//   );
// }

import { Link } from "react-router-dom";
import { Award, Check, ArrowRight, Star } from "lucide-react";
import Reveal from "../components/Reveal";
import SEO from "../components/SEO";
import doctorImage from "./drprateek.jpeg";
import doctorlogo1 from "./doctorlogo1.png";    
import doctorlogo2 from "./doctorlogo2.jpeg";

export default function Doctors() {
  const doctor = {
    name: "Dr. Prateek Aggarwal",
    designation: "Founder • Dentist & Implantologist",

    experience: "16+ Years",

    qualifications: "BDS, MDS - Oral & Maxillofacial Surgery",

    bio: "Dr. Prateek Aggarwal is a leading dentist and implantologist with over 16 years of clinical experience. He has successfully treated thousands of patients with dental implants, smile designing, root canal treatment, cosmetic dentistry, and full mouth rehabilitation. His patient-first approach and advanced clinical expertise make him one of the most trusted dentists in Ghaziabad.",

    expertise: [
      "Dental Implants (Single & Multiple)",
      "Full Mouth Rehabilitation",
      "Smile Designing & Veneers",
      "Wisdom Tooth Surgery",
      "Root Canal Treatment",
      "Dental Crowns & Bridges",
      "Invisible Aligners",
      "Teeth Whitening",
    ],

    credentials: [
      "Member - Indian Dental Association (IDA)",
      "Certified Implantologist",
      "Advanced Training in Cosmetic Dentistry",
      "NABH Accredited Clinic",
      "Verified Dentist on Practo",
      "10,000+ Happy Patients",
    ],
  };

  return (
    <div className="pt-24 pb-20 px-5 md:px-8">
      <SEO
        title="Dentist in Ghaziabad | Dr Prateek Aggarwal"
        description="Meet Dr. Prateek Aggarwal - Trusted Dentist & Implantologist in Ghaziabad."
        path="/doctors"
      />

      {/* Heading */}

      <section className="max-w-5xl mx-auto mb-5">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
          {/* Heading */}
          <div className="text-center">
            <div className="eyebrow mb-4">Meet Our Doctor</div>

            <h1 className="h-display text-5xl md:text-7xl leading-none">
              Hands you can
              <br />
              <span className="italic text-cocoa">truly trust.</span>
            </h1>
          </div>

          {/* Logo */}
          {/* <img
            src={doctorlogo1}
            alt="Logo"
            className="w-32 md:w-40 lg:w-56 xl:w-64 h-auto object-contain"
          /> */}
        </div>
      </section>

      {/* Doctor Card */}

      <section className="max-w-7xl mx-auto">
        <Reveal>
          <div className="grid lg:grid-cols-12 rounded-[35px] overflow-hidden bg-beige">
            {/* Left Image */}

            <div className="lg:col-span-5 h-[650px]">
              <img
                src={doctorImage}
                alt="Doctor Parteek"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Right */}

            <div className="lg:col-span-7 p-8 lg:p-14 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-5">
                <Star size={14} className="fill-cocoa text-cocoa" />

                <span className="uppercase tracking-[4px] text-xs text-cocoa">
                  4.9 Rating • Trusted By Patients
                </span>
              </div>

              <h2 className="text-5xl lg:text-6xl font-serif mb-3">
                {doctor.name}
              </h2>

              <p className="uppercase tracking-[4px] text-sm text-mocha font-semibold mb-5">
                {doctor.designation}
              </p>

              <div className="flex flex-wrap gap-3 mb-8">
                <span className="px-4 py-2 rounded-full bg-white text-sm">
                  {doctor.experience}
                </span>

                <span className="px-4 py-2 rounded-full bg-white text-sm">
                  {doctor.qualifications}
                </span>

                <span className="px-4 py-2 rounded-full bg-black text-white flex items-center gap-2 text-sm">
                  <Award size={14} />
                  NABH Accredited
                </span>
              </div>

              <p className="text-inkmuted leading-8 mb-10">{doctor.bio}</p>

              {/* Button + Logo */}
              {/* Button + Logo */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
                <Link
                  to="/booking"
                  className="inline-flex w-fit items-center justify-center gap-2 px-6 py-3 rounded-full bg-black text-white whitespace-nowrap hover:opacity-90 transition"
                >
                  Book Consultation
                  <ArrowRight size={18} />
                </Link>

                {/* Logos */}
                <div className="flex justify-center sm:justify-start items-center gap-4">
                  <img
                    src={doctorlogo2}
                    alt="Logo 1"
                    className="w-[140px] sm:w-[160px] md:w-[180px] lg:w-[220px] xl:w-[260px] h-auto object-contain"
                  />

                  <img
                    src={doctorlogo1}
                    alt="Logo 2"
                    className="w-[140px] sm:w-[140px] md:w-[150px] lg:w-[170px] xl:w-[170px] h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Bottom */}

        {/* Bottom */}

        <div className="max-w-6xl mx-auto mt-8 px-4 sm:px-6 lg:px-0">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
            {/* Expertise */}

            <Reveal>
              <div className="bg-white border border-[#e7dccd] rounded-[24px] p-5 md:p-6 h-full flex flex-col">
                <h3 className="uppercase tracking-[3px] text-[11px] text-cocoa mb-5">
                  Areas Of Expertise
                </h3>

                <ul className="space-y-3 flex-1">
                  {doctor.expertise.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <Check
                        size={15}
                        className="text-cocoa mt-1 flex-shrink-0"
                      />

                      <span className="text-[13px] md:text-sm leading-6 text-gray-700">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            {/* Credentials */}

            <Reveal delay={0.1}>
              <div className="bg-[#2d241d] text-white rounded-[24px] p-5 md:p-6 h-full flex flex-col">
                <h3 className="uppercase tracking-[3px] text-[11px] text-[#d8c7b0] mb-5">
                  Credentials
                </h3>

                <ul className="space-y-3 flex-1">
                  {doctor.credentials.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <Award
                        size={15}
                        className="text-yellow-300 mt-1 flex-shrink-0"
                      />

                      <span className="text-[13px] md:text-sm leading-6 text-white/80">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}